import React, { createContext, useState, useContext, useEffect } from 'react';
import { api } from '../api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUser = async () => {
      const storedUser = localStorage.getItem('chooziq_user');
      const token = sessionStorage.getItem('chooziq_token') || localStorage.getItem('chooziq_token');
      if (storedUser && token) {
        try {
          const latestUser = await api.get('/user');
          setUser(latestUser);
          localStorage.setItem('chooziq_user', JSON.stringify(latestUser));
        } catch (err) {
          console.error('Failed to fetch latest user', err);
          setUser(JSON.parse(storedUser));
        }
      }
      setLoading(false);
    };
    fetchUser();
  }, []);

  const storeAuth = (userData, token) => {
    localStorage.setItem('chooziq_user', JSON.stringify(userData));
    localStorage.setItem('chooziq_token', token);
    sessionStorage.setItem('chooziq_token', token);
  };

  const clearAuth = () => {
    localStorage.removeItem('chooziq_user');
    sessionStorage.removeItem('chooziq_token');
    localStorage.removeItem('chooziq_token');
  };

  const login = async (email, password) => {
    try {
      const data = await api.post('/login', { email, password });
      storeAuth(data.user, data.token);
      setUser(data.user);
      return { success: true, user: data.user };
    } catch (err) {
      return { success: false, message: err.message || 'Invalid credentials' };
    }
  };

  const signup = async (userData) => {
    try {
      const data = await api.post('/register', userData);
      storeAuth(data.user, data.token);
      setUser(data.user);
      return { success: true, user: data.user };
    } catch (err) {
      return { 
        success: false, 
        message: err.message || 'Signup failed',
        errors: err.errors
      };
    }
  };

  const updateUser = async (data) => {
    try {
      const updatedUser = await api.put('/user', data);
      localStorage.setItem('chooziq_user', JSON.stringify(updatedUser));
      setUser(updatedUser);
      return { success: true };
    } catch (err) {
      return { 
        success: false, 
        message: err.message || 'Update failed',
        errors: err.errors
      };
    }
  };

  const logout = async () => {
    try {
      await api.post('/logout');
    } catch (err) {
      console.error('Logout failed', err);
    } finally {
      clearAuth();
      setUser(null);
    }
  };

  return (
    <AuthContext.Provider value={{ user, login, signup, updateUser, logout, loading }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
